<div class="feedback-stoff">
  <div class="form-group">
    <div class="uba-control-group left-aligned">
      <label
        class="required"
        [translate]="'feedback.beschreibung'"
        for="dossier_fb_comment"
      ></label>
      <div class="uba-form-control">
        <textarea
          class="form-control"
          rows="5"
          placeholder="{{ 'feedback.beschreibung' | translate }}"
          [(ngModel)]="createFeedback.beschreibung"
          name="dossier_fb_comment"
          id="dossier_fb_comment"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group left-aligned">
      <label
        [translate]="'feedback.objektTyp'"
        for="context"
      ></label>
      <div class="uba-form-control">
        <input
          type="text"
          class="form-control"
          [disabled]="true"
          value="{{ 'objektTyp.' + createFeedback.objekt.typ | translate }}"
          name="context"
          id="context"
        />
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group left-aligned">
      <label
        [translate]="'feedback.objektId'"
        for="contextNr"
      ></label>
      <div class="uba-form-control">
        <input 
          type="text"
          class="form-control" 
          [disabled]="true" 
          [value]="createFeedback.objekt.id" 
          name="contextNr" 
          id="contextNr" 
        />    
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group left-aligned">
      <label
        class="required"
        [translate]="'feedback.merkmalName'"
        for="merkmal"
      ></label>
      <div class="uba-form-control">
        <input
          type="text"        
          class="form-control"
          [disabled]="true"
          [value]="createFeedback.merkmalName ? createFeedback.merkmalName : ''"
          name="merkmal"
          id="merkmal"
        />
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group left-aligned">
      <label
        class="required"
        [translate]="'feedback.verweise'"
        for="issueNumbers"
      ></label>
      <div class="uba-form-control">
        <input
          type="text"        
          class="form-control"
          [disabled]="true"
          [value]="createFeedback.verweise ? createFeedback.verweise.join(', ') : ''"
          name="issueNumbers"
          id="issueNumbers"
        />
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group left-aligned">
      <label
        for="category"
        class="required"
        [translate]="'feedback.kategorie'"
      ></label>
      <div class="uba-form-control">
        <select 
          id="category"
          name="category"
          class="form-control"
          [(ngModel)]="createFeedback.kategorie">
          <option *ngFor="let item of categoryItems" [ngValue]="item.value">{{ item.text }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group left-aligned">
      <label
        for="priority"
        class="required"
        [translate]="'feedback.prioritaet'"
      ></label>
      <div class="uba-form-control">
        <select 
          id="priority"
          name="priority"
          class="form-control"
          [(ngModel)]="createFeedback.prioritaet">
          <option *ngFor="let item of priorityItems" [ngValue]="item.value">{{ item.text }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-checkbox-group left-aligned">
      <label
        [translate]="'feedback.emailErwartet'"
        for="cb_emailExpected"
      ></label>
      <div>
        <input
          type="checkbox"
          class="k-checkbox"
          [(ngModel)]="createFeedback.emailErwartet"
          [ngModelOptions]="{ standalone: true }"
          name="cb_emailExpected"
          id="cb_emailExpected"
          style="vertical-align: bottom; margin: 0"
        />
      </div>
    </div>
  </div>  
  <div class="form-group">
    <div class="uba-control-group left-aligned">
      <label
        [translate]="'feedback.anhaenge'"
        id="label-file-upload"
        for="file-upload"
      ></label>
    </div>
    <div>
      <app-generic-upload
        [inputId]="'file-upload'"
        [uploadUrl]="uploadUrl"
        [restrictions]="{ maxFileSize: 4194304 }"
        [(files)]="files"
        [multiple]="true"
        [autoUpload]="true"
        [showRetryButton]="true"
        [showRemoveButton]="true"
        (uploadError)="onError($event)"
        aria-labelledby="label-file-upload">
      </app-generic-upload>  
    </div>    
  </div>
  <div class="uba-button-group">
    <button (click)="cancel()" class="btn btn-default">{{ 'action.cancel' | translate }}</button>
    <button (click)="send()" [disabled]="!canSend" class="btn btn-primary">
      <i class="far fa-paper-plane" aria-hidden="true"></i> {{ 'action.send' | translate }}
    </button>
  </div>
</div>

